import React, { ReactElement } from "react";
import SalesSummaryReportList from "../../components/Reports/SalesSummaryReport";
import MainLayout from "../../components/Layouts";

const SalesSummaryReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <SalesSummaryReportList />
    </MainLayout>
  );
}; 

export default SalesSummaryReportPage;
